import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { crmApi, errMsg } from '@crm/api';

export const fetchOverview = createAsyncThunk(
  'crmOverview/fetch',
  async (
    { branchId, monthFrom, monthTo, revenueDay, employmentMonth },
    { rejectWithValue },
  ) => {
    try {
      const params = new URLSearchParams();
      if (monthFrom) params.set('monthFrom', monthFrom);
      if (monthTo) params.set('monthTo', monthTo);
      if (revenueDay) params.set('revenueDay', revenueDay);
      if (employmentMonth) params.set('employmentMonth', employmentMonth);
      const qs = params.toString();
      const { data } = await crmApi(branchId).get(qs ? `/overview?${qs}` : '/overview');
      return { branchId, data };
    } catch (err) {
      return rejectWithValue(errMsg(err, 'Не удалось загрузить сводку'));
    }
  },
);

const slice = createSlice({
  name: 'crmOverview',
  initialState: { byBranch: {} },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOverview.pending, (state, action) => {
        const branchId = action.meta.arg.branchId;
        if (!state.byBranch[branchId]) state.byBranch[branchId] = {};
        state.byBranch[branchId].status = 'loading';
      })
      .addCase(fetchOverview.fulfilled, (state, action) => {
        const { branchId, data } = action.payload;
        state.byBranch[branchId] = { ...data, status: 'idle' };
      })
      .addCase(fetchOverview.rejected, (state, action) => {
        const branchId = action.meta.arg.branchId;
        state.byBranch[branchId] = {
          ...(state.byBranch[branchId] ?? {}),
          status: 'error',
          error: action.payload,
        };
      });
  },
});

export const overviewSelectors = {
  select: (branchId) => (state) => state.crmOverview.byBranch[branchId] ?? null,
};

export default slice.reducer;
